import * as React from "react";
const SvgLibrary = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_1", "data-name": "Layer 1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M2.04,4.06h4.22c.49,0,.9.42.9.93v17.45c0,.35-.26.62-.6.62H1.74c-.33,0-.6-.27-.6-.62V4.99c0-.51.41-.93.9-.93Z", style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("path", { d: "M14.0375,5.08l3.6619-.99c.4552-.12.9205.14,1.0419.57l4.3194,16.54c.0809.3-.1113.59-.4147.68l-4.2081,1.13c-.3136.08-.6069-.08-.6879-.37L13.4103,6.09c-.1214-.43.1619-.89.6171-1.02l.0101.01Z", style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }), /* @__PURE__ */ React.createElement("path", { d: "M8.05.94h4.22c.49,0,.9.49.9,1.08v20.32c0,.4-.26.72-.6.72h-4.82c-.33,0-.6-.32-.6-.72V2.02c0-.59.41-1.08.9-1.08Z", style: {
  fill: "none",
  stroke: "currentColor",
  strokeMiterlimit: 10,
  strokeWidth: 2
} }));
export default SvgLibrary;
